import { Box, Flex, Icon, Link, Text, VStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import iconEmptyFolder from '~/assets/svgs/icon-empty-folder.svg?react'
import iconXMagnifyingGlass from '~/assets/svgs/icon-x-magnifying-glass.svg?react'
import { useContactsListEmptyNoticeStyle } from '~/pages/Contacts/componentStyles/ContactsListEmptyNotice.style'

interface ContactsListEmptyNoticeProps {
  searchTerm?: string
}
export const ContactsListEmptyNotice = ({
  searchTerm,
}: ContactsListEmptyNoticeProps) => {
  const variant = searchTerm ? 'search' : undefined
  const styles = useContactsListEmptyNoticeStyle({ variant: variant })
  const emptyNoticeContent = useMemo(() => {
    if (!searchTerm || searchTerm.length === 0) {
      return (
        <>
          <Icon as={iconEmptyFolder} sx={styles.icon} />
          <Text sx={styles.warningText}>No Contacts here yet</Text>
          <Text sx={styles.descriptionText}>
            Contact our support team to connect your patient contacts. Internal
            extensions will also appear here after you set them up at{' '}
            <Link href="https://admin.mangovoice.com" target="_blank">
              admin.mangovoice.com
            </Link>
          </Text>
        </>
      )
    }

    return (
      <>
        <Icon as={iconXMagnifyingGlass} sx={styles.icon} />
        <Text sx={styles.warningText}>No Contacts Found</Text>
        <Box textAlign="center">
          <Text sx={styles.descriptionText}>
            We didn't find any contacts matching{' '}
          </Text>
          <Text sx={styles.searchContextText}>"{searchTerm}"</Text>
        </Box>
      </>
    )
  }, [searchTerm])
  return (
    <Flex sx={styles.container} width="100%" height="100%">
      <VStack display="flex" sx={styles.contentStack}>
        {emptyNoticeContent}
      </VStack>
    </Flex>
  )
}
